import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SendolaPayLogo from "@/assets/Img/logo-sendola-pay-white.png";
import WomanWithPhone from "@/assets/Img/send-money-woman-with-phone.png";
import DiscoverSendolaMockUp from "@/assets/Img/discover-sendola.png";
import CardSendIcon from "@/assets/Icons/card-send.svg?react";
import PaymentIcon from "@/assets/Icons/payment.svg?react";
import { Button } from "@/components/Button";
import { Card } from "@/components/Card";
import HubspotContactForm from "@/components/HubspotContactForm";
import ManWithPhone from "@/assets/Img/man-with-phone.png";

const WebsiteUrl = import.meta.env.VITE_SENDOLA_WEBSITE;

const INVITE_TEXT =
  "Te invito a conocer Sendola Pay! para envíos de dinero a México desde Estados Unidos utilizando tu :iphone:y ofrece muchas formas de pago disponibles 🚀 Visita ";

export default function HomePage() {
  const [t] = useTranslation("global");

  const shareInvite = () => {
    if (navigator?.share || navigator?.canShare()) {
      const shareOptions: ShareData = {
        text: INVITE_TEXT,
        url: WebsiteUrl,
      };

      navigator.share(shareOptions);
    }
  };

  useEffect(() => {
    if (window && window.location?.hash) {
      const id = window.location.hash.replace("#", "");
      const element = document.getElementById(id);

      if (element) element.scrollIntoView();
    }
  }, []);

  return (
    <>
      <div className="w-full">
        <div className="relative w-full flex justify-center h-[100vh] max-h-[300px] bg-gradient-to-b from-[#497DF9] md:from-50% to-[#0A2053] z-30 overflow-hidden">
          <div className="w-full h-full flex items-end justify-around relative max-w-screen-xl px-6 md:px-10">
            <div className="py-12 flex flex-col items-center justify-center self-center max-w-[48rem] min-w-60">
              <p
                className="w-full text-3xl xl:text-4xl text-center md:text-left text-white [&_span]:font-semibold"
                dangerouslySetInnerHTML={{ __html: t("Home.heading.title") }}
              />
              <p className="w-full text-xl xs:text-2xl lg:text-3xl text-center md:text-left text-white font-light max-sm:mt-8">
                {t("Home.heading.doItWith")}
                <img
                  className="inline h-12 xs:h-14 xl:h-16 w-auto object-contain select-none -translate-y-2"
                  src={SendolaPayLogo}
                  alt="Sendola's Logo"
                />
              </p>
            </div>
            <div className="hidden md:flex w-full justify-end items-start max-w-[40%]">
              <img
                src={WomanWithPhone}
                alt="Mujer que envía dinero"
                className="hidden md:block w-full max-w-[20rem]  absolute bottom-0"
              />
            </div>
          </div>
        </div>

        {/* <div className="w-full h-auto flex justify-center bg-lightblue px-6 md:px-10">
          <div className="w-full pt-6 pb-16 flex flex-col md:flex-row items-center justify-center gap-x-6 gap-y-2 max-w-screen-xl">
            <div className="w-full bg-white border-[1px] border-gray-300 py-6 px-6 rounded-lg flex flex-col sm:flex-row justify-between md:justify-center items-center self-stretch gap-x-8 gap-y-4">
              <div className="flex flex-col gap-[2px]">
                <p className="text-[16px] font-semibold text-center leading-tight">
                  {t("Home.sendMoney")}
                </p>
                <a
                  href="#benefits"
                  className="flex gap-1 justify-center items-center w-full cursor-pointer"
                >
                  <p className="text-sm underline text-primary-500 font-medium text-center leading-tight">
                    {t("Home.knowMore")}
                  </p>
                  <ArrowDown className="w-5 h-5 text-primary-500" />
                </a>
              </div>

              <Button
                link={`${AuthUrl}/sign-up`}
                className="!text-xs md:!text-sm !font-medium !h-fit xl:max-w-none xl:!px-8"
              >
                {t("Home.join")}
              </Button>
            </div>
            <div className="w-full bg-white border-[1px] border-gray-300 py-6 px-6 rounded-lg flex flex-col sm:flex-row justify-between md:justify-center items-center self-stretch gap-x-8 gap-y-4">
              <div className="flex flex-col gap-[4px]">
                <p className="text-[16px] font-semibold text-center leading-tight">
                  {t("Home.receiveMoney")}
                </p>
                <p className="text-sm text-[#656972] font-medium text-center leading-tight">
                  {t("Home.shareLink")}
                </p>
              </div>

              <Button
                onClick={shareInvite}
                className="!text-xs md:!text-sm !font-medium !h-fit xl:max-w-none xl:!px-8"
              >
                {t("Home.askFor")}
              </Button>
            </div>
          </div>
        </div> */}

        <div className="w-full flex justify-center min-h-32 pt-8 lg:pt-16 bg-gradient-to-br from-[#EDF8FF] to-[#CFEDFF]">
          <div className="w-full flex flex-col-reverse md:flex-row gap-4 px-6 md:px-10 max-w-screen-xl">
            <div className="flex flex-col sm:flex-row lg:flex-col md:flex-col justify-between gap-4 w-full md:1/3 lg:w-5/12 max-md:items-center max-md:mt-6 min-w-[15rem]">
              <div className="flex flex-col items-center md:items-start gap-1 w-full sm:min-w-[12rem] md:min-w-none md:max-w-md">
                <p className="text-2xl md:text-3xl font-semibold text-[#1B326D] text-center">
                  {t("Home.welcomeSendola")}
                </p>
                <p className="text-lg text-center">{t("Home.discover")}</p>
                <a
                  href={WebsiteUrl}
                  className="rounded-full bg-primary-500 hover:opacity-95 text-white w-fit leading-tight font-medium px-8 !py-3 mt-4"
                >
                  {t("Home.knowSendola")}
                </a>
              </div>

              <img
                className="w-full h-auto max-w-[18rem] md:max-w-[24rem] mt-6"
                src={DiscoverSendolaMockUp}
              />
            </div>

            <div className="flex flex-col gap-6 w-full md:2/3 lg:w-7/12">
              <div className="flex flex-col items-center gap-1 w-full bg-white rounded-3xl py-6 px-8">
                <p className="text-lg md:text-xl lg:text-2xl w-full font-semibold text-center text-[#1B326D]">
                  {t("Home.cards.title")}
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-between gap-x-4 w-fit mt-3">
                  <div className="flex items-center gap-2 min-w-fit">
                    <PaymentIcon className="w-8 h-8 text-primary-500 -mb-1" />
                    <p className="text-sm sm:text-base md:text-sm lg:text-base">
                      {t("Home.cards.cashPickup")}
                    </p>
                  </div>
                  <p className="text-gray-400 leading-tight">{t("Home.or")}</p>
                  <div className="flex items-center gap-2 min-w-fit">
                    <CardSendIcon className="w-8 h-8 text-primary-500 -mb-1" />
                    <p className="text-sm sm:text-base md:text-sm lg:text-base">
                      {t("Home.cards.directToBank")}
                    </p>
                  </div>
                </div>
                <p className="w-full text-center text-lg lg:text-xl font-light mt-1">
                  <span>{t("Home.in")}</span>
                  <span className="font-semibold text-[#098B45]">
                    {" "}
                    {t("Home.finaBien")}
                  </span>
                </p>

                <div className="w-full h-[1px] bg-gray-200 my-4" />

                <p className="w-full text-center leading-tight text-sm lg:text-base">
                  {t("Home.cards.description")}
                </p>
                <p
                  className="w-full text-center text-gray-500 leading-tight [&_span]:font-semibold text-sm lg:text-base"
                  dangerouslySetInnerHTML={{ __html: t("Home.cards.banks") }}
                />
              </div>

              <div className="flex flex-col justify-center items-center gap-6 w-full md:min-h-52 bg-gradient-to-r from-[#C1CFFE] via-[#D4F2FD] to-[#F4FCFF] rounded-3xl p-8 pb-6">
                <div className="flex flex-col sm:flex-row items-start gap-4">
                  <p className="text-2xl lg:text-3xl font-bold w-full text-center sm:text-left sm:max-w-[14rem] text-[#1A1A1A] md:mt-5">
                    {t("Home.coupon.title")}
                  </p>

                  <div className="flex flex-col items-center justify-center gap-3">
                    <p className="text-2xl lg:text-3xl text-white font-semibold uppercase bg-gradient-to-b from-[#2586F1] to-[#0BCFFF] px-2 py-1 rounded-lg">
                      {t("Home.coupon.couponName")}
                    </p>
                    <p
                      className="text-lg lg:text-xl text-center leading-tight [&_span]:font-semibold text-[#1A1A1A]"
                      dangerouslySetInnerHTML={{
                        __html: t("Home.coupon.description"),
                      }}
                    />
                    <Button
                      onClick={shareInvite}
                      className="rounded-full bg-primary-500 hover:opacity-95 text-white w-fit leading-tight font-medium !px-10 !py-2"
                    >
                      {t("Home.share")}
                    </Button>
                  </div>
                </div>
                <p className="w-full text-center text-xs text-[#656972]">
                  {t("Home.coupon.disclaimer")}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-center bg-gradient-to-br from-[#EFF3FD] to-[#DCE5FC] py-10 px-6 md:px-10 overflow-hidden">
          <div className="w-full flex justify-center max-w-screen-xl">
            <div className="flex flex-col gap-6 w-full lg:flex-row max-w-screen-sm lg:max-w-none">
              <div className="flex flex-col items-center justify-between lg:mt-6 w-full lg:w-1/2 self-stretch">
                <div className="flex flex-col items-center md:items-start w-full lg:w-fit lg:min-w-[20rem]">
                  <h2
                    className="font-semibold text-2xl md:text-3xl text-[#1B326D] w-fit"
                    dangerouslySetInnerHTML={{ __html: t("Home.form.title") }}
                  />
                  <p
                    className="md:text-lg mt-1 w-fit"
                    dangerouslySetInnerHTML={{
                      __html: t("Home.form.subtitle"),
                    }}
                  />
                </div>

                <img
                  src={ManWithPhone}
                  className="hidden lg:block w-80% h-auto object-contain translate-y-12 object-bottom max-w-xl"
                />
              </div>

              <div className="flex justify-center w-full lg:w-1/2 !h-min">
                <Card className="!shadow-none !rounded-3xl !w-full !max-w-screen-md !p-0 border-[1px] border-primary-100">
                  <HubspotContactForm
                    portalId="44207752"
                    formId="6d370d15-1244-458f-9686-bf6ea0fe4b47"
                    region="na1"
                  />
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hidden"></div>
    </>
  );
}
